<template>
  <xt-dialog-web title="请输入验证码" no-button :visible="visible" @cancel="close">
    <div class="xt-message-web-new">
      <div style="margin-top: -20px;" class="xt-message__subtitle">验证码已发送到您尾号{{ tailNumber }}的手机</div>
      <div class="xt-message__numbers"
           @click="$refs['code-input'].focus()">
        <template v-for="(code,index) in codes">
          <div ref="code"
               class="xt-message__number"
               :class="index === curIndex ? 'focus' : ''"
          >{{ code }}
          </div>
        </template>
      </div>
      <div style="position:relative;">
        <input v-model="code" @keydown.delete.prevent="onDelete" class="hidden_input" ref="code-input" type="tel"/>
        <!--错误信息的-->
        <div v-if="showErrorMessage">
          <div class="xt-message__error">{{ errorMessage }}</div>
        </div>
      </div>
      <div class="xt-message__functions" ref="changeClass">
        <span class="xt-message__wait" style="margin-left: 0px;" v-if="waitSecond > 0">重新发送({{ waitSecond }})</span>
        <span class="xt-message__resend" style="margin-left: 2px;" v-else @click="sendMessage()">重新发送</span>
        <span class="xt-message__no-code" style="margin-left: 85px;" ref="kfClass" @click="isCallTel()">联系客服</span>
      </div>
      <!--重新发送margin-left: 2px  113        0 85  倒计时  -->
      <div class="show-voice-div">
      <span class="" ref="voiceClass">没收到短信？点击获取
        <span class="content-voice-link" ref="clickClass" @click="sendVoiceCode">语音验证码</span>
      </span>
      </div>
      <div style="margin: 40px auto 0 auto;width: 228px;"></div>
      <!--      <xt-button-web style="margin: 40px auto 0 auto;width: 228px;" @click="verifyCodeNow">确定</xt-button-web>-->
      <xt-dialog-web :visible="showDialog"
                     confirm-text="确定"
                     @cancel="showDialog = false"
                     @confirm="confirm()">
        <div style="text-align: center;margin: 20px 0;">
          {{TelAndWorkdayTimeText}}
        </div>
      </xt-dialog-web>
    </div>

  </xt-dialog-web>
</template>
<script>
import {sendMessage, verifyMessage, sendVoiceMessage} from "../service/support";
import {userInfo} from "../service/user";
import XtDialogWeb from "./xtDialogWebNew";
import XtButtonWeb from "./xtButtonWeb";
import {TelAndWorkdayTimeText} from "@/common/constant";
import { getFailCount } from "../service/login";
import { CAPTCHA_DATA } from "@/common/webTracing";

export default {
  components: {XtButtonWeb, XtDialogWeb},
  props: {
    mobileProp: {
      type: String,
      default: null
    },
    userName: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: 'redeem'
    },
    onSend: {
      type: Function,
      required: false
    },
    onSendVoice: {
      type: Function,
      required: false
    },
    onVerify: {
      type: Function,
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    code: {
      handler(newValue) {
        this.code = ''
        let isEnter = newValue.length > 0
        if (isEnter) {
          if (!/^[0-9]+$/.test(newValue)) {
            newValue = null
            return
          }
          this.onEnter(newValue)
        }
      }
    },
    visible: {
    async  handler(cur) {
        if (cur) {
          this.$nextTick(() => this.$refs['code-input'].focus())
          const count = await getFailCount(this.userName)
          if (count >= 3) {
            this.initTimer()
          } else {
            this.loadMobile().then(() => {
            this.sendMessage()
           })
          }
          
        } else{
          //清除掉之前的定时器
          this.timer && clearInterval(this.timer)
        }
      },
      immediate: true,
      deep: true
    }
  },
  computed: {
    tailNumber() {
      return this.mobile.substring(this.mobile.length - 4)
    },
    mobile() {
      if (this.mobileProp) {
        return this.mobileProp
      }
      return this.mobileOfUser
    }
  },
  data() {
    return {
      TelAndWorkdayTimeText:TelAndWorkdayTimeText,
      codes: [null, null, null, null, null, null],
      curIndex: 0,
      waitSecond: 60,
      waitSecondVoice: 60,
      showErrorMessage: false,
      errorMessage: '',
      mobileOfUser: '',
      onStart: true,
      code: '',
      showDialog: false,
      timer:null
      //showVoice :true,
    }
  },
  async mounted() {
  },
  methods: {
    onEnter(string) {
      this.errorMessage = ''
      this.backDivClass();
      for (let i = 0; i < string.length && this.curIndex < this.codes.length; i++) {
        this.codes[this.curIndex] = string[i]
        this.curIndex++
      }
      if(this.codes && this.codes.join('').length >= 6) {
        this.verifyCodeNow()
      }
    },
    onDelete() {
      this.showErrorMessage = false
      this.backDivClass();
      if (this.curIndex === 0) {
        this.codes[this.curIndex] = null
      } else {
        this.codes[--this.curIndex] = null
      }
    },
    initTimer() {
      if(this.timer) {
        clearInterval(this.timer)
      }
      this.waitSecond = 60
      this.timer =  setInterval(()=>{
        this.waitSecond--
        if(this.waitSecond <=0) {
          this.backKfClass();
          clearInterval(this.timer)
          this.timer = null
        }
      },1000)
    },
    /**
     * 语音倒计时
     */
    initTimerVoice() {
      this.waitSecondVoice = 60;
      this.decreaseWaitTimeVoice()
    },
    decreaseWaitTimeVoice() {
      if (this.waitSecondVoice <= 0) {
        this.showCommonSpan();
        return
      }
      this.waitSecondVoice--
      setTimeout(this.decreaseWaitTimeVoice, 1000)
    },
    //语音验证码置灰
    showGreeSpan() {
      if (this.$refs.voiceClass != undefined) {
        this.$refs.voiceClass.style = "color: #CCCCCC;";
      }
      if (this.$refs.clickClass != undefined) {
        this.$refs.clickClass.style = "color: #CCCCCC;";
      }
    },
    ////语音验证码 样式还原
    showCommonSpan() {
      if (this.$refs.voiceClass != undefined) {
        this.$refs.voiceClass.style = "";
      }
      if (this.$refs.clickClass != undefined) {
        this.$refs.clickClass.style = "color:#6496DB;";
      }
    },
    //
    changeDivClass() {
      if (this.$refs.changeClass != undefined) {
        this.$refs.changeClass.style = "margin-top: 10px;";
      }
    },
    backDivClass() {
      if (this.$refs.changeClass != undefined) {
        this.$refs.changeClass.style = "margin-top: 0px;";
      }
    },
    //联系客户向左调整
    changeKfClass() {
      if (this.$refs.kfClass != undefined) {
        this.$refs.kfClass.style = "margin-left: 85px;";
      }
    },
    backKfClass() {
      if (this.$refs.kfClass != undefined) {
        this.$refs.kfClass.style = "margin-left: 113px;";
      }
    },
    async verifyCodeNow() {
      let code = this.codes.join('')
      if (code && code.length >= 6) {
        let response = await this.verifyCode()

        console.log('response', response)
        this.errorMessage = '验证码错误，请重新输入'
        if (typeof response === 'object') {
          if (Number(response.code) === 200) {
            this.success()
          } else {
            console.error('异常返回', response)
            this.errorMessage = response.message || this.errorMessage
            this.showErrorMessage = true
            this.changeDivClass();
          }
        } else if (response === 'success') {
          this.success()
        } else {
          this.showErrorMessage = true
          this.changeDivClass();
        }
      } else {
        this.errorMessage = '验证码不能为空，请输入验证码'
        this.showErrorMessage = true
      }
    },
    async sendMessage() {
      this.showErrorMessage = false
      this.backDivClass();
      this.changeKfClass();
      this.initTimer()
      try {
        this.$tracingTrace(CAPTCHA_DATA.smsCaptcha);
        if (this.onSend && typeof this.onSend === 'function') {
          await this.onSend(this.mobile)
        } else {
          await sendMessage(this.type)
        }
      } catch (error) {
        if (error.code === '5') {
          this.errorMessage = '获取验证码失败，请重新获取'
          this.showErrorMessage = true
        }
      }

    },
    /**
     * 发送语音验证码
     */
    async sendVoiceCode() {
      if (this.waitSecondVoice == 60 || this.waitSecondVoice == 0) {
        this.showErrorMessage = false;
        this.backDivClass();
        this.initTimerVoice();
        this.showGreeSpan();
        try {
          this.$tracingTrace(CAPTCHA_DATA.voiceCaptcha);
          if (this.onSendVoice && typeof this.onSendVoice === 'function') {
            await this.onSendVoice(this.mobile)
          } else {
            await sendVoiceMessage(this.type);
          }
        } catch (error) {
          this.errorMessage = '获取验证码失败，请重新获取'
          this.showErrorMessage = true;
        }
      }
    },
    async isCallTel() {
      this.showDialog = true
    },
    async confirm() {
      this.showDialog = false
      // this.callTel()
    },
    async verifyCode() {
      let codes = this.codes.join('')
      if (this.onVerify && typeof this.onVerify === 'function') {
        return await this.onVerify({mobile: this.mobile, code: codes})
      } else {
        return await verifyMessage({mobile: this.mobile, areaCode: codes})
      }
    },
    async loadMobile() {
      if (!this.mobileProp) {
        let userData = await userInfo()
        this.$store.commit('updateMobile', userData.mobile)
        this.mobileOfUser = userData.mobile
      }
    },
    moveEnd(obj) {
      obj.focus();
      let len = obj.value.length;
      if (document.selection) {
        let sel = obj.createTextRange();
        sel.moveStart('character', len);
        sel.collapse();
        sel.select();
      } else if (typeof obj.selectionStart == 'number'
          && typeof obj.selectionEnd == 'number') {
        obj.selectionStart = obj.selectionEnd = len;
      }
    },
    close() {
      this.codes = [null, null, null, null, null, null]
      this.curIndex = 0
      this.$emit('close')
    },
    success() {
      this.$emit('success')
    },
    reset() {
      this.codes = [null, null, null, null, null, null]
      this.curIndex = 0
      this.sendMessage()
    }
  }
}
</script>
<style lang="less">
.xt-message-web-new {
  .verify-title {
    height: 25px;
    font-size: 18px;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    text-align: center;
  }
  .xt-message__subtitle {
    text-align: center;
    font-size: 15px;
    margin-top: 20px;
    color: #333;
  }

  .xt-message__numbers {
    display: flex;
    margin: 15px 0 15px 0;
    justify-content: center;

    .xt-message__number {
      box-sizing: border-box;
      width: 32px !important;
      height: 32px !important;
      line-height: 32px;
      margin-right: 7px;
      border: 1px solid #666;
      border-radius: 0;
      font-size: 20px;
      outline: none;
      box-shadow: none;
      text-align: center;
      -webkit-appearance: none;
      padding: 0;

      &:last-child {
        margin-right: 0;
      }

      &.focus {
        border-color: #497AC0;
      }
    }
  }

  .hidden_input {
    width: 0;
    height: 0;
    outline: none;
    box-shadow: none;
    border: none;
  }

  .xt-message__functions {
    font-size: 15px;
    padding: 0 5px;
    display: flex;
    justify-content: center;

    .xt-message__resend {
      color: #497AC0;
      cursor: default;
    }

    .xt-message__wait {
      color: #999;
    }

  }

  .xt-message__no-code {
    margin-left: 20px;
    color: #497AC0;
  }

  .xt-message__error {
    margin-top: -19px;
    text-align: center;
    color: #BB0000;
  }

  .show-voice-div {
    font-size: 15px;
    padding: 0 5px;
    display: flex;
    justify-content: center;
    margin-top: 13px;
    margin-left: -5px;
    /*margin-left: 431px;*/
  }

  .content-voice-link {
    text-decoration: underline;
    color: #497AC0;
    cursor: pointer;

    &:hover {
      color: #6496DB;
    }
  }
}

</style>
